import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// ✅ Set theme BEFORE rendering App
const domain = window.location.hostname;
const theme = domain.includes("betterworks.asia") ? "bwa" : "default";
document.documentElement.setAttribute("data-theme", theme);

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
